{
    "monster": {
        "key": "monster",
        "jobKey": "book/ghost",
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        }
    },
    "ashe": {
        "position": {
            "x": 5,
            "y": 6,
            "z": 1
        },
        "templateKey": "player/book/ashe",
        "key": "ashe"
    }
}
